import React from 'react';
import { LandingScopeGroupProps } from './ILandingScopeGroup';
import _SearchBar from '../../components/shared/_SearchBar';
import AnswerCard from './AnswerCard';
import Panel from '../../components/ui/Panel';
import Container from '../../components/ui/Container';
import ImageLayout from '../../layouts/ImageLayout';
import Breadcrumbs from '../../components/Breadcrumbs';
import { default as BannerImage } from '../../assets/images/banner-particulier.jpg';

export const LandingScopeGroupPage: React.FC<LandingScopeGroupProps> = ({
  productgroupsDropdownList,
  isParticulier,
  productGroups,
}) => {
  const breadcrumbLinks = [
    { name: 'Home', linkTo: '/' },
    {
      name: isParticulier ? 'Particulier' : 'Zakelijk',
      linkTo: isParticulier ? '/particulier' : '/zakelijk'
    },
  ];

  const searchTitle: string = isParticulier
    ? 'Zoek een dienstverlener'
    : 'Zoek een zakelijke adviseur';

  const formattedGroup = productgroupsDropdownList?.map(
    ({ text: label, ...rest }) => ({
      label,
      ...rest,
    })
  );

  return (
    <ImageLayout
      breadcrumbs={<Breadcrumbs variant="inverted" links={breadcrumbLinks} />}
      image={BannerImage as string}
    >
      <Container state="imageLayoutFirst">
        <_SearchBar searchTitle={searchTitle} options={formattedGroup} />
        <Panel className="mt-16 flex-col" position="last">
          <AnswerCard productGroups={productGroups} />
        </Panel>
      </Container>
    </ImageLayout>
  );
};
